/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/**
 * Mensajes rotativos para la barra de búsqueda móvil.
 * Solo cambian cuando el campo está vacío y no está siendo utilizado.
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-rotating-placeholders]').forEach(function (input) {
    var messages = (input.getAttribute('data-rotating-placeholders') || '')
      .split('|')
      .map(function (message) { return message.trim(); })
      .filter(Boolean);

    if (messages.length < 2) {
      return;
    }

    var currentIndex = 0;

    window.setInterval(function () {
      if (document.activeElement === input || input.value.trim() !== '') {
        return;
      }

      currentIndex = (currentIndex + 1) % messages.length;
      input.setAttribute('placeholder', messages[currentIndex]);
    }, 3200);
  });
});


/**
 * Búsqueda predictiva inline para la barra principal del encabezado.
 * Muestra resultados debajo de la barra y evita abrir el drawer lateral.
 */
document.addEventListener('DOMContentLoaded', function () {
  var predictiveApiSupported = false;

  try {
    var featuresScript = document.getElementById('shopify-features');
    if (featuresScript) {
      predictiveApiSupported = !!JSON.parse(featuresScript.textContent).predictiveSearch;
    }
  } catch (error) {
    predictiveApiSupported = false;
  }

  document.querySelectorAll('.cec-header-search').forEach(function (searchWrapper) {
    var form = searchWrapper.querySelector('.cec-header-search__form');
    var input = searchWrapper.querySelector('[data-inline-predictive-search-input]');
    var results = searchWrapper.querySelector('.cec-header-search__results');
    var debounceTimer = null;
    var abortController = null;

    if (!form || !input || !results) {
      return;
    }

    function positionResults() {
      var formBottom = form.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--cec-search-results-top', Math.max(0, Math.round(formBottom + 8)) + 'px');
    }

    function closeResults() {
      results.hidden = true;
      results.innerHTML = '';
      searchWrapper.classList.remove('is-open');
      document.documentElement.classList.remove('cec-search-active');
    }

    function openResults() {
      document.documentElement.classList.add('cec-search-active');
      window.requestAnimationFrame(function () {
        positionResults();
        results.hidden = false;
        searchWrapper.classList.add('is-open');
      });
    }

    function renderLoading() {
      results.innerHTML = '<p class="cec-header-search__loading">Buscando...</p>';
      openResults();
    }

    async function performSearch(term) {
      var cleanedTerm = (term || '').trim();

      if (abortController) {
        abortController.abort();
      }

      if (cleanedTerm === '') {
        closeResults();
        return;
      }

      if (!predictiveApiSupported) {
        closeResults();
        return;
      }

      renderLoading();

      try {
        abortController = new AbortController();
        var url = window.themeVariables.routes.predictiveSearchUrl
          + '?q=' + encodeURIComponent(cleanedTerm)
          + '&resources[limit]=10'
          + '&resources[type]=product'
          + '&resources[options[unavailable_products]]=show'
          + '&resources[options[fields]]=title,body,product_type,variants.title,variants.sku,vendor'
          + '&section_id=predictive-search';

        var response = await fetch(url, { signal: abortController.signal });
        var responseText = await response.text();
        var temp = document.createElement('div');
        temp.innerHTML = responseText;
        var section = temp.firstElementChild;
        var html = section ? section.innerHTML.trim() : '';

        if (html === '') {
          results.innerHTML = '<p class="cec-header-search__empty">No se encontraron resultados.</p>';
        } else {
          results.innerHTML = html;
        }

        openResults();
      } catch (error) {
        if (error && error.name === 'AbortError') {
          return;
        }

        closeResults();
      }
    }

    input.addEventListener('input', function () {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () {
        performSearch(input.value);
      }, 220);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim() !== '') {
        performSearch(input.value);
      }
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeResults();
        input.blur();
      }
    });

    document.addEventListener('click', function (event) {
      if (!searchWrapper.contains(event.target)) {
        closeResults();
      }
    });

    window.addEventListener('resize', function () {
      if (!results.hidden) {
        positionResults();
      }
    });

    window.addEventListener('scroll', function () {
      if (!results.hidden) {
        positionResults();
      }
    }, { passive: true });

    results.addEventListener('click', function (event) {
      var resetButton = event.target.closest('[data-action="reset-search"]');
      if (!resetButton) {
        return;
      }

      event.preventDefault();
      input.value = '';
      closeResults();
      input.focus();
    });
  });
});


/**
 * Oculta el menú al superar una distancia estable de scroll.
 * Se vuelve a mostrar únicamente cerca de la parte superior para evitar
 * el parpadeo causado por cambios mínimos de dirección al contraerse el header.
 */
document.addEventListener('DOMContentLoaded', function () {
  var ticking = false;
  var root = document.documentElement;
  var hideAfter = 140;
  var showBefore = 70;

  function updateMenuVisibility() {
    var currentScrollY = window.scrollY || 0;
    var searchResultsOpen = document.querySelector('.cec-header-search.is-open');
    var searchInputFocused = document.activeElement && document.activeElement.hasAttribute('data-inline-predictive-search-input');

    if (searchResultsOpen) {
      root.classList.add('cec-menu-hidden');
    } else if (searchInputFocused || currentScrollY <= showBefore) {
      root.classList.remove('cec-menu-hidden');
    } else if (currentScrollY >= hideAfter) {
      root.classList.add('cec-menu-hidden');
    }

    ticking = false;
  }

  updateMenuVisibility();

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(updateMenuVisibility);
      ticking = true;
    }
  }, { passive: true });
});
